































import { Inject, Component, Vue } from 'vue-property-decorator'
import { ChecklistSettingsAPI } from '@/api/backend-client'
import { ChecklistSettings } from '@/api/model/checklist-settings'

@Component
export default class CompanySettingsChecklistSettings extends Vue {
    @Inject() readonly reloadCompany: () => Promise<void>
    loading: boolean = false
    checklistSettings: ChecklistSettings = null

    async created() {
        await this.reload()
    }

    async reload() {
        this.loading = true
        this.checklistSettings = await ChecklistSettingsAPI.getForCompany(this.$currentCompany)
        this.loading = false
    }

    async save() {
        try {
            this.loading = true
            await ChecklistSettingsAPI.update(this.checklistSettings.id, this.checklistSettings)
            await this.reloadCompany()
            await this.reload()

        } finally {
            this.loading = false
        }
    }
}
